import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-191cf3de")
const _hoisted_1 = { class: "contents inner how-to-use" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("使い方")
const _hoisted_3 = { class: "flex-box jc-sb" }
const _hoisted_4 = { class: "img-box computer" }
const _hoisted_5 = { class: "controll-area" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_heading = _resolveComponent("heading")!
  const _component_retina_img = _resolveComponent("retina-img")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_heading, {
      level: 2,
      textAlign: "center"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_retina_img, {
          src: `/images/how-to-use-0${_ctx.curStep + 1}.png`,
          alt: `画面スクリーンショット${_ctx.curStep}`,
          width: 800,
          height: 421,
          loading: "lazy"
        }, null, 8, ["src", "alt"])
      ]),
      _createElementVNode("ol", _hoisted_5, [
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.curStep === 0 }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurStep(0)))
        }, " Step1：ルームを作成する ", 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.curStep === 1 }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCurStep(1)))
        }, " Step2：問題を追加する ", 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.curStep === 2 }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setCurStep(2)))
        }, " Step3：受講者に共有する ", 2),
        _createElementVNode("li", {
          class: _normalizeClass({ 'is-active': _ctx.curStep === 3 }),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurStep(3)))
        }, " Step4：進捗を管理する ", 2)
      ])
    ])
  ]))
}